import { createFileRoute } from '@tanstack/react-router';

import InstallerInstallation from '@/ui/pages/Installer/InstallerInstallation/InstallerInstallation';

export const Route = createFileRoute('/_dashboard/installer/installations/$id/')({
  component: InstallerInstallation,
});
